import React from 'react';
import { 
    MapPinIcon, 
    PhoneIcon, 
    PhotoIcon, 
    MapIcon,
    DocumentDuplicateIcon,
    BuildingOffice2Icon
} from '@heroicons/react/24/outline';

const formatPhoneNumber = (phone) => {
    if (!phone) return "";
    const cleaned = String(phone).replace(/\D/g, "");
    if (cleaned.length === 10) return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    if (cleaned.length === 9) return `${cleaned.slice(0, 2)}-${cleaned.slice(2, 5)}-${cleaned.slice(5)}`;
    return phone;
};

const HospitalCard = ({ index, data, onOpenMap, onOpenPicture, onCopy }) => {
    const googleMap = data.map;
    const info = `${data.hname}\n${data.address}\n${data.codeAddress}\nโทร. ${data.phone}\nแผนที่:${googleMap?.split(",")[0]}`;

    return (
        <div className="group relative bg-white border-2 border-slate-100 rounded-2xl p-4 transition-all duration-300 hover:shadow-xl hover:shadow-blue-900/10 hover:border-blue-200 hover:-translate-y-1 flex flex-col sm:flex-row sm:items-center gap-4">
            <div className="hidden sm:flex items-center justify-center w-10 h-10 rounded-xl bg-gradient-to-br from-blue-50 to-orange-50 text-slate-600 font-black text-sm group-hover:from-blue-600 group-hover:to-orange-600 group-hover:text-white transition-all duration-500 shrink-0 shadow-sm">
                {String(index + 1).padStart(2, '0')}
            </div>

            <div className="flex-1 space-y-2">
                <div className="flex flex-wrap items-center gap-2">
                    <BuildingOffice2Icon className="w-4 h-4 text-blue-600 flex-shrink-0" strokeWidth={2} />
                    <h4 className="text-sm md:text-base font-black text-slate-900 group-hover:text-blue-600 transition-colors leading-tight">
                        {data.hname}
                    </h4>
                    <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gradient-to-r from-orange-100 to-orange-50 border border-orange-200 text-orange-700 text-[9px] font-black uppercase tracking-wider">
                        {data.codeAddress?.split(",")[1] || 'Network'}
                    </span>
                </div>

                <div className="flex items-start gap-2 text-slate-600">
                    <MapPinIcon className="w-3.5 h-3.5 mt-0.5 flex-shrink-0 text-slate-400" strokeWidth={2} />
                    <p className="text-xs leading-relaxed">{data.address}</p>
                </div>
            </div>

            <div className="flex items-center gap-2 pt-3 sm:pt-0 border-t border-slate-100 sm:border-none shrink-0 flex-wrap sm:flex-nowrap">
                <a 
                    href={`tel:${data.phone}`}
                    className="flex-1 sm:flex-none flex items-center justify-center gap-1.5 bg-gradient-to-r from-blue-900 to-blue-800 text-white px-3 py-2 rounded-xl hover:from-orange-600 hover:to-orange-500 transition-all duration-300 active:scale-95 shadow-md"
                >
                    <PhoneIcon className="w-3.5 h-3.5" strokeWidth={2.5} />
                    <span className="font-bold text-xs">{formatPhoneNumber(data.phone)}</span>
                </a>
                
                <button 
                    onClick={() => onOpenMap(data)} 
                    className="p-2.5 rounded-xl bg-orange-50 text-orange-600 border border-orange-100 hover:bg-orange-600 hover:text-white transition-all duration-300 active:scale-95"
                    aria-label="ดูแผนที่"
                >
                    <MapIcon className="w-4 h-4" strokeWidth={2} />
                </button>
                
                <button 
                    onClick={() => onOpenPicture(data)} 
                    className="p-2.5 rounded-xl bg-blue-50 text-blue-600 border border-blue-100 hover:bg-blue-600 hover:text-white transition-all duration-300 active:scale-95"
                    aria-label="ดูรูปภาพ"
                >
                    <PhotoIcon className="w-4 h-4" strokeWidth={2} />
                </button>
                
                <button 
                    onClick={() => onCopy(info)} 
                    className="p-2.5 rounded-xl bg-slate-50 text-slate-500 border border-slate-100 hover:bg-slate-600 hover:text-white transition-all duration-300 active:scale-95"
                    aria-label="คัดลอกข้อมูล"
                >
                    <DocumentDuplicateIcon className="w-4 h-4" strokeWidth={2} />
                </button>
            </div>
        </div>
    );
};

export default HospitalCard;
